import { useSubsequentEffect } from '@carvana/merch-react-hooks';
import { useContext, useEffect, useRef } from 'react';
import { useTrackEvent } from '~/context/common/AnalyticsProvider';
import MegaEventContext from '~/context/home/MegaEventContext';

export default function useTrackMegaVehicle() {
  const { triggerVehicleEvent, vehicles } = useContext(MegaEventContext);
  const trackEvent = useTrackEvent();

  const vehiclesRef = useRef(vehicles);
  useEffect(() => {
    vehiclesRef.current = vehicles;
  }, [vehicles]);

  useSubsequentEffect(() => {
    trackEvent(
      'mega-home-vehicle-data',
      { vehicles: vehiclesRef.current },
      undefined,
      {
        useFetch: true,
        fetchOption: { keepalive: false }
      }
    );
  }, [trackEvent, triggerVehicleEvent]);
}
